import type { NavigationGroup } from "@/sanity.types";

import { HeaderMegaMenuFeaturedItem } from "./headerMegaMenuFeaturedItem.component";

export const HeaderMegaMenuFeaturedItems = ({
  featuredItems,
}: HeaderMegaMenuFeaturedItemsProps) => {
  const renderFeaturedItems = () => {
    if (!featuredItems?.length) return null;
    return featuredItems.map((item) => (
      <HeaderMegaMenuFeaturedItem key={item._key} item={item} />
    ));
  };
  return (
    <div className="flex flex-1 justify-end">
      <ul className="flex h-full min-h-full gap-4">{renderFeaturedItems()}</ul>
    </div>
  );
};

export type HeaderMegaMenuFeaturedItemsProps = {
  featuredItems?: NavigationGroup["featuredItems"];
};
